/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/more'
export default icon
